<!-- Assign Worker -->
<div class="modal right fade" id="updates" tabindex="-1" role="dialog" aria-labelledby="updatesLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h4 class="modal-title" id="updatesLabel">{{ update_data.title }}</h4>
                <span>{{ update_data.created_at | amDateFormat:'MM/DD/YYYY' }}</span>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p ng-bind-html="update_data.description">
                        </p>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="submit" class="btn btn-primary" ng-click="updates()">Tamam</button>
            </div>
        </div>
    </div>
</div>
